import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { infoToastAction } from 'utils';

import View from './CommandButtons.view';

const CommandButtons = ({
    row,
    col,
    selected,
    onCellClick,
    getExportData,
    fileName
}) => {
    const [viewValidate, setViewValidate] = useState(false);
    const checkedCount = row[col.field];
    const globalDispatch = useDispatch();
    
    const handleToggle = () => {
        if (checkedCount > 0) {
            setViewValidate(!viewValidate);
        } else {
            globalDispatch(infoToastAction('The contract needs to be checked prior to validation'));
        }
    };

    if (!selected || !row.team || !row.appointee) {
        return null;
    }

    return (
        <View
            checkedCount={checkedCount}
            viewValidate={viewValidate}
            handleToggle={handleToggle}
            onCellClick={onCellClick}
            getExportData={getExportData}
            fileName={fileName}
            selected={selected}
        />
    );
};

CommandButtons.propTypes = {
    onCellClick: PropTypes.func.isRequired,
    getExportData: PropTypes.func.isRequired,
    fileName: PropTypes.string.isRequired
};

export default CommandButtons;